import {
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { Button, Image, RichText } from 'shared';

type CateringFormatMainMenusSectionProps = {
    menus: {
        name: string;
        description?: any;
        warning?: string | null | undefined;
        image?: {
            url: string;
        } | null | undefined;
        estimateFile?: {
            url: string;
        } | null | undefined;
    }[]
} & GridProps & React.RefAttributes<HTMLDivElement>

export const CateringFormatMainMenusSection: React.FC<CateringFormatMainMenusSectionProps> = ({
    menus,
    ...props
}) => {
    const [selected, setSelected] = useState(0);

    return (
        <Grid
            background="#000000"
            color="white"
            padding="2rem"
            templateColumns="1fr 2fr"
            gap="2rem"
            {...props}
        >
            <Grid
                height="fit-content"
            >
                {menus.map(({ name }, index) => (
                    <Text
                        fontSize="2rem"
                        fontWeight={900}
                        padding="1rem"
                        width="100%"
                        border={index === selected ? '3px solid #E74C3C' : '3px solid transparent'}
                        cursor="pointer"
                        onClick={() => setSelected(index)}
                    >
                        {name}
                    </Text>
                ))}
            </Grid>
            <Grid
                gap="2rem"
            >
                <RichText
                    fontSize="2rem"
                    content={menus[selected].description}
                />
                <Text
                    fontSize="1.25rem"
                >
                    {menus[selected].warning}
                </Text>
                <Image
                    src={menus[selected].image?.url}
                    aspectRatio="2 / 1"
                    width="100%"
                    objectFit="cover"
                />
                <Button
                    background="#E74C3C"
                    fontWeight={900}
                    onClick={() => {
                        const url = menus[selected].estimateFile?.url;
                        if (url) {
                            window.open(url, '_blank');
                        }
                    }}
                >
                    Скачать PDF
                </Button>
            </Grid>
        </Grid>
    );
};
